{
 "note": "켈틱 크로스 열 자리. name 은 자리 이름, read 는 그 자리를 어떻게 읽는지 한 줄. 카드 뜻과 합쳐 자리별 풀이를 만든다 (src/lib/tarotSpread.ts).",
 "positions": ["now", "cross", "conscious", "unconscious", "past", "coming", "self", "around", "hope", "outcome"],
 "text": {
  "ko": {
   "now": { "name": "현재 상황", "read": "지금 무슨 일이 일어나고 있는지 보여 주는 자리예요." },
   "cross": { "name": "가로막는 것", "read": "무엇이 발목을 잡거나 넘어야 할 벽이 되는지 알려 줘요." },
   "conscious": { "name": "의식하는 것", "read": "스스로 알고 있는 생각과 바라는 목표가 놓이는 자리예요." },
   "unconscious": { "name": "무의식", "read": "밑바탕에 깔려 있어 스스로도 잘 모르는 마음이에요." },
   "past": { "name": "지나온 것", "read": "여기까지 오게 만든 과거가 놓이는 자리예요." },
   "coming": { "name": "다가오는 것", "read": "가까운 앞날에 올 흐름을 보여 줘요." },
   "self": { "name": "나의 태도", "read": "이 일을 대하는 나의 자세가 드러나는 자리예요." },
   "around": { "name": "주변 환경", "read": "둘러싼 사람들과 상황이 어떤지 보여 줘요." },
   "hope": { "name": "희망과 두려움", "read": "바라는 것과 무서운 것이 같이 놓이는 자리예요." },
   "outcome": { "name": "최종 결과", "read": "지금 흐름대로 갔을 때 닿게 되는 자리예요." }
  },
  "en": {
   "now": { "name": "Where you are", "read": "This position shows what is actually going on right now." },
   "cross": { "name": "What crosses you", "read": "This is what gets in the way, or the wall you have to get over." },
   "conscious": { "name": "What you know", "read": "The thoughts you are aware of and the goal you are aiming at." },
   "unconscious": { "name": "Underneath", "read": "What sits at the bottom of this, that even you do not quite see." },
   "past": { "name": "What brought you here", "read": "The past that led to where you are standing." },
   "coming": { "name": "What is coming", "read": "The current arriving in the near future." },
   "self": { "name": "How you stand", "read": "This position shows the attitude you bring to it." },
   "around": { "name": "Around you", "read": "The people and circumstances surrounding this." },
   "hope": { "name": "Hope and fear", "read": "What you want and what you are afraid of, in the same place." },
   "outcome": { "name": "Where it lands", "read": "Where this goes if the current stays as it is." }
  },
  "ja": {
   "now": { "name": "いまの状況", "read": "いま実際に何が起きているかを映す場所です。" },
   "cross": { "name": "さえぎるもの", "read": "足を引っぱるもの、越えるべき壁を教えてくれます。" },
   "conscious": { "name": "意識していること", "read": "自分で分かっている考えと、目指している目標が置かれます。" },
   "unconscious": { "name": "心の底", "read": "下に沈んでいて、自分でもよく見えていない気持ちです。" },
   "past": { "name": "ここまでの道", "read": "いまの場所へ連れてきた過去が置かれます。" },
   "coming": { "name": "近づくもの", "read": "近い先に来る流れを見せてくれます。" },
   "self": { "name": "自分の姿勢", "read": "この件に向き合うときの自分の構えが出る場所です。" },
   "around": { "name": "まわりの環境", "read": "とりまく人と状況がどうなっているかを映します。" },
   "hope": { "name": "望みと怖れ", "read": "望んでいることと怖いことが、同じ場所に置かれます。" },
   "outcome": { "name": "行き着く先", "read": "いまの流れのままなら、たどり着く場所です。" }
  },
  "zh-Hans": {
   "now": { "name": "眼下的处境", "read": "这个位置照出此刻真正在发生的事。" },
   "cross": { "name": "挡路的东西", "read": "告诉你什么绊住了脚，或是要翻过去的墙。" },
   "conscious": { "name": "心里清楚的", "read": "自己知道的念头，和想要达成的目标。" },
   "unconscious": { "name": "心底深处", "read": "压在底下、连自己也看不太清的心思。" },
   "past": { "name": "走过来的路", "read": "把你带到这里的那段过去。" },
   "coming": { "name": "正在靠近的", "read": "近处将要到来的走势。" },
   "self": { "name": "我的姿态", "read": "这个位置显出你面对这件事的态度。" },
   "around": { "name": "周围的环境", "read": "照出身边的人和眼下的情形。" },
   "hope": { "name": "盼望与害怕", "read": "想要的和怕的，放在同一个位置上。" },
   "outcome": { "name": "最后的落点", "read": "照现在这个势头走下去会到的地方。" }
  },
  "zh-Hant": {
   "now": { "name": "眼下的處境", "read": "這個位置照出此刻真正在發生的事。" },
   "cross": { "name": "擋路的東西", "read": "告訴你什麼絆住了腳，或是要翻過去的牆。" },
   "conscious": { "name": "心裡清楚的", "read": "自己知道的念頭，和想要達成的目標。" },
   "unconscious": { "name": "心底深處", "read": "壓在底下、連自己也看不太清的心思。" },
   "past": { "name": "走過來的路", "read": "把你帶到這裡的那段過去。" },
   "coming": { "name": "正在靠近的", "read": "近處將要到來的走勢。" },
   "self": { "name": "我的姿態", "read": "這個位置顯出你面對這件事的態度。" },
   "around": { "name": "周圍的環境", "read": "照出身邊的人和眼下的情形。" },
   "hope": { "name": "盼望與害怕", "read": "想要的和怕的，放在同一個位置上。" },
   "outcome": { "name": "最後的落點", "read": "照現在這個勢頭走下去會到的地方。" }
  },
  "es": {
   "now": { "name": "Dónde estás", "read": "Esta posición muestra lo que está pasando de verdad ahora." },
   "cross": { "name": "Lo que se cruza", "read": "Lo que te frena, o el muro que tienes que pasar." },
   "conscious": { "name": "Lo que sabes", "read": "Los pensamientos que reconoces y la meta a la que apuntas." },
   "unconscious": { "name": "Lo de debajo", "read": "Lo que está en el fondo de esto y ni tú alcanzas a ver del todo." },
   "past": { "name": "Lo que te trajo aquí", "read": "El pasado que te dejó donde estás parado." },
   "coming": { "name": "Lo que se acerca", "read": "La corriente que llega en el futuro cercano." },
   "self": { "name": "Cómo te plantas", "read": "Esta posición muestra la actitud con la que lo tomas." },
   "around": { "name": "A tu alrededor", "read": "Las personas y las circunstancias que rodean esto." },
   "hope": { "name": "Esperanza y miedo", "read": "Lo que quieres y lo que temes, en el mismo lugar." },
   "outcome": { "name": "Dónde aterriza", "read": "Adónde va esto si la corriente sigue como está." }
  },
  "pt-BR": {
   "now": { "name": "Onde você está", "read": "Esta posição mostra o que está acontecendo de verdade agora." },
   "cross": { "name": "O que atravessa", "read": "O que te segura, ou o obstáculo que você precisa superar." },
   "conscious": { "name": "O que você sabe", "read": "Os pensamentos que você reconhece e a meta que você mira." },
   "unconscious": { "name": "O que está embaixo", "read": "O que fica no fundo disso e nem você enxerga direito." },
   "past": { "name": "O que te trouxe aqui", "read": "O passado que deixou você onde está." },
   "coming": { "name": "O que se aproxima", "read": "A corrente que chega no futuro próximo." },
   "self": { "name": "Como você se coloca", "read": "Esta posição mostra a postura com que você encara isso." },
   "around": { "name": "Ao seu redor", "read": "As pessoas e as circunstâncias em volta disso." },
   "hope": { "name": "Esperança e medo", "read": "O que você quer e o que você teme, no mesmo lugar." },
   "outcome": { "name": "Onde isso pousa", "read": "Aonde isso vai se a corrente seguir como está." }
  }
 }
}
